import { requestApi } from '@app/api';
import { withIdentityAccess } from '@app/api/paths';

interface PostUserPasswordResetTokenCheckResponse {
  result: {
    isValid: boolean;
  };
}

/**
 * 비밀번호 재설정 토큰 검사
 */
// eslint-disable-next-line import/prefer-default-export
export function postUserPasswordResetTokenCheck({
  email,
  token,
}: {
  email: string;
  token: string;
}): Promise<boolean> {
  return requestApi<PostUserPasswordResetTokenCheckResponse>({
    url: withIdentityAccess('/user/password/reset/token/check'),
    method: 'POST',
    data: {
      email,
      token,
    },
  }).then((response) => response.data.result.isValid);
}
